import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { TraceService, createErrorHandler } from '@sentry/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CustomLoaderComponent } from './components/custom-loader/custom-loader.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ErrorMonitoringInterceptor } from './interceptors/error-monitoring.interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import localeNor from '@angular/common/locales/nb';
import localeNorExtra from '@angular/common/locales/extra/nb';

registerLocaleData(localeNor, 'no', localeNorExtra);

@NgModule({ declarations: [
        AppComponent,
        CustomLoaderComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        IonicModule.forRoot({ scrollAssist: false, scrollPadding: false }),
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule], providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: LOCALE_ID, useValue: 'no' },
        { provide: ErrorHandler, useFactory: createErrorHandler },
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorMonitoringInterceptor, multi: true }] })
export class AppModule {
  constructor(_trace: TraceService) {}
}
